import { DateTime } from 'luxon';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';
import { useI18nContext } from '@/i18n/i18n-react';
import { useBillingStatus } from '@/hooks/use-billing-status';
import { useTenantNullable } from '@/hooks/use-tenant';
import { getLuxonLocale } from '@/lib/utils';
import type { Locales } from '@/i18n/i18n-types';

function formatDate(iso: string, locale: Locales) {
  return DateTime.fromISO(iso)
    .setLocale(getLuxonLocale(locale))
    .toLocaleString(DateTime.DATE_SHORT);
}

export function AnnouncementBar() {
  const { LL, locale } = useI18nContext();
  const tenant = useTenantNullable();
  const { data } = useBillingStatus();

  if (data?.state !== 'warning' || !data.dashboardBlockedAt || !tenant) {
    return null;
  }

  return (
    <div className="flex w-full shrink-0 items-center justify-center gap-2 bg-destructive px-4 py-1.5 text-center text-destructive-foreground max-md:flex-wrap">
      <span className="text-sm">
        {LL.pastDueWarningBar.message({
          date: formatDate(data.dashboardBlockedAt, locale),
        })}
      </span>
      <Link
        to={`/${tenant.slug}/billing`}
        className="inline-flex shrink-0 items-center gap-1 text-sm font-medium underline decoration-2 underline-offset-2 max-md:min-h-touch"
      >
        {LL.pastDueWarningBar.fixLink()}
        <ArrowRight className="size-3.5" />
      </Link>
    </div>
  );
}
